import React from "react";
import Modal from "react-modal";
import { deleteUserNotification } from "../../services";
import * as s from "./styles";
import { notifyError, notifySuccess } from '../../utils';

const DeleteConfirmation = ({ openModal, setOpenModal, event, buscaNotificacoes  }) => (
    <Modal 
      isOpen={openModal}
      onRequestClose={() => setOpenModal(false)}
      ariaHideApp={false}
      style={s.modalStyle}
    >
      <s.Container>
        <s.CloseButton onClick={() => setOpenModal(false)}>X</s.CloseButton>

        <label>Deseja excluir essa notificação?</label>
        
        <s.ButtonWrapper>
          <s.DeleteButton
              onClick={() => {
                deleteUserNotification(event.id)
                .then(() => {
                  notifySuccess('Deletada com sucesso');
                  buscaNotificacoes();
                })
                .catch(() => notifyError('Não foi possivel deletar a notificação.'))
                setOpenModal(false);
            }}
          >
            Excluir
          </s.DeleteButton>

          <s.CancelButton
            onClick={() => setOpenModal(false)}
          >
            Cancelar
          </s.CancelButton>
        </s.ButtonWrapper>
      </s.Container>
    </Modal>
  );

export default DeleteConfirmation;
